import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { VmwareNetworkPicker } from './VmwareNetworkPicker';

export const VmwareNetworkPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'VmwareNetworkPicker',
    component: VmwareNetworkPicker,
  }),
);
